<template>
  <v-container
    class="pa-0"
  >
    <v-card
      v-if="form"
      tile
      flat
      class="pa-3 pt-0"
    >
      <s-person-info-toolbar />

      <div class="section-header">
        <span>{{ $t('Main.Training') }}</span>
      </div>

      <div class="section-header">
        <span>{{ $t('PublicServant.Me.Training.standardTraining') }}</span> <!-- 達標式培訓課程 -->
      </div>

      <v-simple-table>
        <v-col
          cols="12"
          md="10"
        >
          <v-simple-table class="mb-2">
            <thead>
              <tr>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingName') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingEntityName') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingStartDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingEndDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingCertDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingNumberOfHours') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="lang in standardTraining"
                :key="lang.languageTypeId"
              >
                <td>{{ $chPtObjData('chinDesc', lang) }} - {{ lang.promoTrainTypeId }}</td>
                <!-- TODO: handle i18n -->
                <td>{{ $chPtObjData('trainingInstChinDesc', lang) }}</td>
                <td>{{ lang.startDate }}</td>
                <td>
                  {{ lang.endDate }}
                </td>
                <td>
                  {{ lang.certIssueDate }}
                </td>
                <td>{{ lang.idurationInHours }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          {{ $t('PublicServant.Me.Training.TrainingTotalHours') }} : {{ standardSum }}
        </v-col>
      </v-simple-table>

      <div class="section-header">
        <span>{{ $t('PublicServant.Me.Training.readingTraining') }}</span> <!-- 修讀式培訓課程 -->
      </div>

      <v-simple-table>
        <v-col
          cols="12"
          md="10"
        >
          <v-simple-table class="mb-2">
            <thead>
              <tr>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingName') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingEntityName') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingStartDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingEndDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingCertDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingNumberOfHours') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="lang in readingTrainingList"
                :key="lang.languageTypeId"
              >
                <td>{{ $chPtObjData('chinDesc', lang) }} - {{ lang.promoTrainTypeId }}</td>
                <!-- TODO: handle i18n -->
                <td>{{ $chPtObjData('trainingInstChinDesc', lang) }}</td>
                <td>{{ lang.startDate }}</td>
                <td>
                  {{ lang.endDate }}
                </td>
                <td>
                  {{ lang.certIssueDate }}
                </td>
                <td>{{ lang.idurationInHours }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          {{ $t('PublicServant.Me.Training.TrainingTotalHours') }} : {{ readingSum }}
        </v-col>
      </v-simple-table>

      <div class="section-header">
        <span>{{ $t('PublicServant.Me.Training.OtherTrainings') }}</span>
      </div>
      <v-simple-table>
        <v-col
          cols="12"
          md="10"
        >
          <v-simple-table class="mb-2">
            <thead>
              <tr>
                <th class="text-xs-left ">
                  {{ $t('PublicServant.Me.Training.TrainingName') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingEntityName') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingStartDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingEndDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingCertDate') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('PublicServant.Me.Training.TrainingNumberOfHours') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="lang in otherTraining"
                :key="lang.languageTypeId"
              >
                <td>{{ $chPtObjData('chinDesc', lang) }} - {{ lang.promoTrainTypeId }}</td>
                <!-- TODO: handle i18n -->
                <td>{{ $chPtObjData('trainingInstChinDesc', lang) }}</td>
                <td>{{ lang.startDate }}</td>
                <td>
                  {{ lang.endDate }}
                </td>
                <td>
                  {{ lang.certIssueDate }}
                </td>
                <td>{{ lang.idurationInHours }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          {{ $t('PublicServant.Me.Training.TrainingTotalHours') }} : {{ otherTrainingSum }}
        </v-col>
      </v-simple-table>

      <!-- internalProposeFormList -->
      <div class="section-header">
        <span>{{ $t('PublicServant.Me.internalPropose') }}</span>
      </div>
      <v-simple-table>
        <v-col
          cols="12"
          md="10"
        >
          <v-simple-table class="mb-2">
            <thead>
              <tr>
                <th class="text-xs-left ">
                  {{ $t('TrainingClient.courseAbility') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('TrainingClient.InternalPropose.className') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('TrainingClient.InternalPropose.trainingReasonShort') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('TrainingClient.InternalPropose.classQuarterVenue') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('TrainingClient.InternalPropose.teachingLanguage') }}
                </th>
                <th class="text-xs-left">
                  {{ $t('TrainingClient.InternalPropose.expectation') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="l in internalProposeFormList"
                :key="l.internalProposeFormDetailId"
              >
                <td>{{ $chPtObjData('chinCourseAbilityBrief', l) }}</td>
                <!-- TODO: handle i18n -->
                <td>{{ $chPtObjData('chinDraftYearCourseName', l) }}</td>
                <td>{{ $chPtObjData('portObjectiveTypeDesc', l) }}</td>
                <td>
                  {{ $chPtObjData('chinTimeUnit', l) }}
                </td>
                <td>
                  {{ l.languageChinName }}
                </td>
                <td>{{ l.expectation }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-simple-table>
    </v-card>
  </v-container>
</template>

<script>

// import bdrhApi from '../../api/hr/bdrh'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import bdrhStaff from '../../store/modules/hr/bdrhStaff'
import store from '../../store'
import { mapState } from 'vuex'
import { bdrhStaffModule, staffModule, globalModule } from '../../store/moduleName'

import SPersonInfoToolbar from './components/SPersonInfoToolbar.vue'
import taskListApi from '../../api/training/taskList'
import courseApi from '../../api/training/course'
import { breakSubErrors } from '../../utils/messageUtil'
import { parseJwt } from '../../utils/utils'
import { getStorage } from '../../utils/storageUtil'

if (!store.state[bdrhStaffModule]) store.registerModule(bdrhStaffModule, bdrhStaff)

export default {
  components: { SPersonInfoToolbar },
  data: function () {
    return {
      standardTraining: null,
      directTrainingHours: null,
      indirectTrainingHours: null,
      readingTrainingList: null,
      otherTraining: null,
      internalProposeFormList: null,
      staffCode: null

    }
  },
  computed: {
    ...mapState({
      form: state => state[staffModule].info,
      bdrh: state => state[bdrhStaffModule].info
    }),
    standardSum () {
      if (this.standardTraining) {
        return this.standardTraining.reduce((sum, t) => t.idurationInHours * 1.0 + sum, 0)
      }
      return 0
    },
    readingSum () {
      if (this.readingTrainingList) {
        return this.readingTrainingList.reduce((sum, t) => t.idurationInHours * 1.0 + sum, 0)
      }
      return 0
    },
    otherTrainingSum () {
      if (this.otherTraining) {
        return this.otherTraining.reduce((sum, t) => t.idurationInHours * 1.0 + sum, 0)
      }
      return 0
    }
  },
  created () {
    console.log('this.form: ' + this.form)
    if (!this.form) {
      // this.$router.push('/humanResources/PersonInfo')
    }
    this.$store.dispatch(staffModule + '/getStaff')
    // bdrhApi.getStaff(staff => {
    //   this.form = staff
    // })
    let token = parseJwt(getStorage('g2e-jwt-token'))
    console.log('g2e-jwt-token: ' + JSON.stringify(token))
    this.staffCode = token.staff_code
    console.log('staffCode : ' + this.staffCode)
    // this.staffCode = '0000000308'
    this.getTrainingInfoByStaffCode()
  },
  methods: {
    momentWithHyphen: momentWithHyphen,

    getTrainingInfoByStaffCode () {
      console.log('getTrainingInfoByStaffCode start : ')
      taskListApi.getTrainingInfo2(resp => {
        console.log('getTrainingInfoByStaffCode : ' + JSON.stringify(resp))
        if (resp.data) {
          console.log('getTrainingInfoByStaffCode, standardTraining : ' + JSON.stringify(resp.data.standardTraining))
          console.log('getTrainingInfoByStaffCode, readingTraining : ' + JSON.stringify(resp.data.readingTraining))
          console.log('getTrainingInfoByStaffCode, otherTraining : ' + JSON.stringify(resp.data.otherTraining))
        }

        if (resp.status === 201 || resp.status === 200) {
          if (resp.data) {
            this.standardTraining = resp.data.standardTraining
            if (resp.data.readingTraining) {
              this.directTrainingHours = resp.data.readingTraining.directTrainingHours
              this.indirectTrainingHours = resp.data.readingTraining.indirectTrainingHours
              this.readingTrainingList = resp.data.readingTraining.readingTrainingList
            }
            this.otherTraining = resp.data.otherTraining
          }
          console.log('directTrainingHours, ' + this.directTrainingHours + ' : ' + this.indirectTrainingHours)
        } else if (resp.status === 400) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$chPtObjData('chinMessage', breakSubErrors(resp.data.subErrors)))
        } else {
          console.log(this.$t('System.Busy'))
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('System.Busy'))
        }
      }, this.staffCode)

      courseApi.getInternalProposeFormList(resp => {
        console.log('getInternalProposeFormList : ' + JSON.stringify(resp))

        if (resp.status === 201 || resp.status === 200) {
          this.internalProposeFormList = resp.data
          // console.log('internalProposeFormList, ' + this.internalProposeFormList + ' : ')
        } else if (resp.status === 400) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$chPtObjData('chinMessage', breakSubErrors(resp.data.subErrors)))
        } else {
          console.log(this.$t('System.Busy'))
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('System.Busy'))
        }
      }, this.staffCode)
    }

  }
}
</script>
